export enum ErpSyncSystemStatus {
    InSync = 'in-sync',
    OutOfSync = 'out-of-sync',
}
